<template>
  <div>
    <label :class="priceClassName || ''">{{ price }}</label>
  </div>
</template>
<script>
import { BaseProgress } from "@/components/index";
import swal from "sweetalert2";

export default {
  name: "price-label",
  components: {},

  created() {},
  props: {
    price: String,
    priceClassName: String,
  },
  methods: {},
};
</script>

<style>
.text-success{
  color: green !important;
}
</style>